const TRIGGER_ERROR_ON_LOAD = 'trigger-error-on-load';

export default {
  TRIGGER_ERROR_ON_LOAD,
};
